/**
 * Expressão Regular utilizada para interpolação global de variáveis {{chave}} no Renderer
 */
export const VARIABLE_INTERPOLATION_PATTERN = /\{\{([^}]+)\}\}/g;

export const TEMPLATE_TOKEN_PATTERN = /\{\{([^}]*)\}\}/g;
